
import AbstractModel from "@/models/AbstractModel";

/**
 *  Eine Kombi ist eine mögliche Kombination aus
 * 	verschiedenen Komponenten.
 *
 */
class Kombi extends AbstractModel {
	
    get defaultData() {
        return {
			className: 'Kombi',
			uid: false,
		}
	}

	/**
	 *  Eine (temporäre) uid erzeugen
	 */
	createUid( data ) {
		if (this.uid) return;
		// UID generieren
		var arr = [];
		for (var n in data) {
			var item = data[n];
			if (typeof item == 'object' && item.typ) {
				arr.push(item.typ.substr(0,3));
			}
		}
		this.uid = arr.join('.');
	}

	/**
	 * 	Prüft, ob diese Element gegebene Kriterien erfüllt.
	 */
	matches( criteria ) {
		var diff = this.diff( criteria );
		return Object.keys(diff).length == 0;
	}
	
	/**
	 * 	Prüft, welche Kritierien NICHT erfüllbar sind.
	 */
	conflicts( criteria ) {
		var conflicts = {};
		var diff = this.diff( criteria, true );
		return diff;
	}

	/**
	 * 	Findet Unterschiede zwischen diesem Element und gegebenen Kriterien.
	 * 	Gibt Unterschiede als assoziatives Array zurück:
	 * 
	 * 	{bereich:'nasal', ...}
	 */
	diff( criteria, returnCriteria ) {
		var diff = {};
		for (var key in criteria) {
			var v = this[key] ? this[key].typ : '';
			if (!v || v != criteria[key]) {
				diff[key] = returnCriteria ? criteria[key] : v;
			}
		}
		return diff;
	}
}

export default Kombi;



// WEBPACK FOOTER //
// ./src/models/Kombi.js